import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CashroomPage } from './cashroom';

@NgModule({
  declarations: [
    CashroomPage,
  ],
  imports: [
    IonicPageModule.forChild(CashroomPage),
  ],
})
export class CashroomPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cashroom/cashroom.module.ts